import CRUDServiceOperations from "./CRUDServiceOperations";

class LifeCycleClassDefinitionService extends CRUDServiceOperations {
  getLifeCycleClassDefinition(
    lifeCycleClassDefinitionId,
    callback,
    failureCallback
  ) {
    const url = this.urlFactory.lifeCycleClassDefinition(
      lifeCycleClassDefinitionId
    );
    return this.getEntitiesByUrl(url, callback, failureCallback);
  }

  getEntitiesUrl = () => {
    return this.urlFactory.lifeCycleClassDefinitions();
  };
}

export default LifeCycleClassDefinitionService;
